var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{staticStyle:{"width":"5rem","height":"5rem"},attrs:{"label":"Login..."}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }